import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card, CardContent, CardDescription, CardHeader } from '@codes/ui-kit/components/ui/card';

interface StatisticsCardsProps {
    statistics: {
        totalSessions: number;
        totalApiCalls: number;
        totalDuration: string;
        avgResponseTime: string;
    };
}

export const StatisticsCards: React.FC<StatisticsCardsProps> = ({ statistics }) => {
    const { t } = useTranslation();

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[26px]">
            <Card>
                <CardHeader className="pb-2">
                    <CardDescription>{t('logs.statistics.totalSessions')}</CardDescription>
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold">
                        {statistics.totalSessions}
                        {t('logs.statistics.sessions')}
                    </div>
                </CardContent>
            </Card>
            <Card>
                <CardHeader className="pb-2">
                    <CardDescription>{t('logs.statistics.totalApiCalls')}</CardDescription>
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold text-blue-600">
                        {statistics.totalApiCalls}
                        {t('logs.statistics.calls')}
                    </div>
                </CardContent>
            </Card>
            <Card>
                <CardHeader className="pb-2">
                    <CardDescription>{t('logs.statistics.totalUsageTime')}</CardDescription>
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold">{statistics.totalDuration}</div>
                </CardContent>
            </Card>
            <Card>
                <CardHeader className="pb-2">
                    <CardDescription>{t('logs.statistics.avgResponseTime')}</CardDescription>
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold text-green-600">{statistics.avgResponseTime}</div>
                </CardContent>
            </Card>
        </div>
    );
};
